import { render } from "./right.vue?vue&type=template&id=e6d88d5a"
const script = {}
script.render = render

export default script